// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // PARSE_APP_ID: 'lSOnVnARd7qFJaWm4Iq56DxUXbJzJ2CYHZa437pp',
  // PARSE_JS_KEY: 'PK8z76wZ9mz0wTraT7dtMFTX4AsofMXuyWY1Y8zE',
  PARSE_APP_ID: 'm7iNpdInibNdO57FLW43oulPxnpnoskR12iWb9qT',
  PARSE_JS_KEY: 'egRqRwmY1BrDtYj6wfsRfxzifDhnpsauDsmqAkii',
  serverURL: 'https://parseapi.back4app.com',
  baseURL: 'https://cors-anywhere.herokuapp.com/https://platform.fatsecret.com'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
